import { apiClient } from '@/lib/api-client';
import { createCrudHooks } from './create-crud-hooks';

export const {
  keys: songKeys,
  useList: useSongs,
  useInfiniteList: useInfiniteSongs,
  useDetail: useSong,
  useCreate: useCreateSong,
  useUpdate: useUpdateSong,
  useDelete: useDeleteSong,
} = createCrudHooks(apiClient['songs'], 'songs');
